module.exports = __webpack_public_path__ + "img/Obstfelder_De_roede_draaber.9f2e6916.jpg";